import { shuffleArray } from "./shuffleArray";

export const getRandomElements = <T>(array: T[], number: number) => {
    return shuffleArray(array).slice(0, number);
};
